import { handleAddressSubmitOneToMany } from '../../../components/address-book/utils/handle-address-submit-one-to-many';

export const onHandleGoNext = ({ projectId, addressFormValues, increaseAddressCounter, resetFormAddresses }) => {
  handleAddressSubmitOneToMany(projectId, addressFormValues).then(() => {
    increaseAddressCounter();
    resetFormAddresses();
  });
};
